import { formatISO } from 'date-fns';

export const formatISODate = (date: Date) =>
  formatISO(date, { representation: 'date' });
